import React, { memo } from "react";

const StarsBackground = () => null;

export default memo(StarsBackground);
